export class SortValueConverter {
	toView(array: any, propertyName: any, direction: any) {
		var factor = direction === 'ascending' ? 1 : -1;

		if (!array) return array;

		return array
			.slice(0)
			.sort((a, b) => {
				return a[propertyName] < b[propertyName]
					? -1 * factor
					: factor;
			});
	}
}
